module.exports = __webpack_public_path__ + "static/media/img-function-rec.d887ae47.png";